import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DemoCohortProvider } from './contexts/DemoCohortContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <DemoCohortProvider>
          <App />
        </DemoCohortProvider>
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>,
);

reportWebVitals();
